import { InfoCircleOutlined } from "@ant-design/icons";
import { BILLING_TYPES } from "@features/AddBrandAccounting/model/types";
import { IBrandAccounting } from "@shared/lib/types/accounting";
import { RadioInput } from "@shared/ui/RadioInput";
import { Flex, Input, Modal } from "antd";
import dayjs from "dayjs";
import styles from "./styles.module.scss";
import { TransactionDetails } from "./TransactionDetails";

interface ViewTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
  transaction: IBrandAccounting | null;
}

export function ViewTransactionModal({
  isOpen,
  onClose,
  transaction,
}: ViewTransactionModalProps) {
  if (!transaction) {
    return null;
  }

  const campaignNames =
    transaction.briefs
      ?.map((b) => b.name)
      .filter(Boolean)
      .join(", ") ?? "N/A";

  return (
    <Modal
      title="View Document"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Flex vertical gap={10}>
        {transaction.brandLedgerIds &&
          transaction.brandLedgerIds.length > 0 && (
            <TransactionDetails transaction={transaction} />
          )}
        <div className={styles.form}>
          <div className={styles.section}>
            <label className={styles.label}>Select Type</label>
            <div className={styles.radioGroup}>
              {BILLING_TYPES.map((type) => (
                <RadioInput
                  key={type}
                  isSelected={transaction?.subType === type}
                  handleSelect={() => {}}
                  // handleSelect={() => onBillingTypeChange(type)}
                >
                  {type}
                </RadioInput>
              ))}
            </div>
          </div>

          <div className={styles.infoBox}>
            <InfoCircleOutlined className={styles.infoIcon} />
            <span className={styles.infoText}>
              Payment Terms: <strong>Net 30 Days</strong>
            </span>
          </div>
          {transaction?.url ? (
            <div className={styles.section}>
              <label className={styles.label}>{transaction?.subType}</label>
              <a href={transaction?.url} target="_blank" rel="noreferrer">
                {transaction?.url}
              </a>
            </div>
          ) : null}

          <div className={styles.row}>
            <div className={styles.field}>
              <label className={styles.label}>
                {transaction?.subType} Number
              </label>
              <Input
                value={transaction?.accountingNumber ?? transaction?._id}
                // onChange={(e) => onInvoiceNumberChange(e.target.value)}
                className={styles.input}
                disabled
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>
                {transaction?.subType} Date
              </label>
              <Input
                type="date"
                value={dayjs(transaction?.date).format("YYYY-MM-DD")}
                disabled
                // onChange={(e) => {
                //   onInvoiceDateChange(e.target.value);
                // }}
                className={styles.input}
              />
            </div>
          </div>

          <div className={styles.section}>
            <label className={styles.label}>Total Amount (Incl. Tax)</label>
            <div className={styles.amountWrap}>
              <span className={styles.currency}>₹</span>
              <Input
                type="number"
                value={transaction?.totalAmount}
                disabled
                // onChange={(e) =>
                //   onInvoiceAmountChange(
                //     e.target.value === "" ? "" : Number(e.target.value)
                //   )
                // }
                placeholder="0.00"
                className={styles.amountInput}
              />
            </div>
          </div>
        </div>
      </Flex>
    </Modal>
  );
}
